import { render, staticRenderFns } from "./CalendarViewWeek.vue?vue&type=template&id=4b5700ae&scoped=true"
import script from "./CalendarViewWeek.vue?vue&type=script&lang=js"
export * from "./CalendarViewWeek.vue?vue&type=script&lang=js"
import style0 from "./CalendarViewWeek.vue?vue&type=style&index=0&id=4b5700ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5700ae",
  null
  
)

export default component.exports